var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueContainer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_141_7826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3958 24.6314V14.195L9.60417 11.3687V21.805C9.60412 22.0442 9.72248 22.2833 9.95916 22.4199L22.6358 29.7957C22.8676 29.9296 23.1307 30 23.3984 30C23.6662 30 23.9292 29.9296 24.1611 29.7957L32.0408 25.2463C32.2775 25.1097 32.3958 24.8705 32.3958 24.6314Z",
    fill: "url(#paint0_linear_141_7826)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.95939 10.7537L17.8392 6.20436C18.071 6.07048 18.3341 6 18.6018 6C18.8695 6 19.1326 6.07048 19.3644 6.20436L32.041 13.5801C32.5144 13.8534 32.5144 14.5365 32.041 14.8098L24.1612 19.3592C23.9294 19.4931 23.6663 19.5635 23.3986 19.5635C23.1308 19.5635 22.8678 19.4931 22.6359 19.3592L9.95939 11.9834C9.48609 11.7102 9.48609 11.027 9.95939 10.7537Z",
    fill: "#7A7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6271 25.5347L17.4502 26.01V17.1541L16.6271 16.6789V25.5347ZM21.5661 19.5304V28.3862L22.476 28.9116V20.0558L21.5661 19.5304ZM18.2734 17.6294V26.4852L19.0965 26.9605V18.1046L18.2734 17.6294ZM14.9807 24.5842L15.8039 25.0595V16.2036L14.9807 15.7283V24.5842ZM19.9197 18.5799V27.4357L20.7429 27.911V19.0551L19.9197 18.5799ZM14.1576 15.2531L13.3727 14.7999V23.6558L14.1576 24.109V15.2531ZM10.8769 13.3474L10.092 12.8943V21.7501L10.8769 22.2033V13.3474ZM11.6881 22.6568L12.5113 23.132V14.2762L11.6881 13.8009V22.6568Z",
    fill: "#4747FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8649 13.3257L10.0801 12.8726V21.7285L10.8649 22.1816V13.3257Z",
    fill: "#4747FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0292 17.8886L24.2903 20.056V28.9118L28.0292 26.7444V17.8886ZM28.3845 17.683V26.5388L31.7682 24.5844V15.7285L28.3845 17.683Z",
    fill: "#2C2CAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9618 22.2925L27.4159 23.185C27.2601 23.2749 27.1338 23.1795 27.1338 22.9718C27.1338 22.7642 27.2601 22.5229 27.4159 22.433L28.9618 21.5404C29.1175 21.4505 29.2438 21.546 29.2438 21.7536C29.2438 21.9613 29.1175 22.2026 28.9618 22.2925Z",
    fill: "#7A7AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_141_7826",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.166667 0 0 0 0 0.166667 0 0 0 0 0.166667 0 0 0 0.42 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_141_7826"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_141_7826",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_141_7826",
    x1: 22.648,
    y1: 20.6844,
    x2: 24.8963,
    y2: 20.6844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4747FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueContainer);
export default __webpack_public_path__ + "static/media/blue_container.b1d343fe559741eb34dd5f8fd5594b36.svg";
export { ForwardRef as ReactComponent };